<template>
    <div class="pager-container">
        <div class="pager-selected">
            <!-- 上一页按钮 -->
            <div class="arrow-container" :class="(currPager === 1 || currPager === 0) ? 'not-cursor' : 'yes-cursor'" @click="prevPage()">
                <p :class="(currPager === 1 || currPager === 0) ? 'no-lt' : 'lt'"></p>
            </div>
            <!-- 页码按钮 -->
            <div v-for="(item, index) of pages" :key="index" class="pager-number" :class="currPager===item?'on-selected':''" @click.self="jumpPager($event, item)"> {{item}} </div>
            <!-- 下一页按钮 -->
            <div class="arrow-container" :class="(currPager === totalPager || currPager === 0) ? 'not-cursor' : 'yes-cursor'" @click="nextPage()">
                <p :class="(currPager === totalPager || currPager === 0) ? 'no-gt' : 'gt'"></p>
            </div>
        </div>
        <div class="pager-go">
            <span>到第</span>
            <input type="text" :value="currPager" @keyup.self="fliterNumber($event)" @afterpaste.self="fliterNumber($event)" :placeholder="currPager">
            <span>页</span>
            <input type="button" class="mouse-selected" value="确定" @click.self="goPager($event)">
        </div>
        <div class="pager-unit">
            <span>共{{totalCount}}条</span>
            <select v-model="unitPager"  @change.self="changeUnit($event)" >
                <option v-for="(item, index) of listOfSelect" :key="index" :value='item'>{{item}}条/页</option>
            </select>
        </div>
    </div>
</template>
<script>
export default {
    name:'pagerComponent',
    props: {
        currentPager: {  //当前页
            type: Number,
            default: 1
        },
        totalCount: {  //总条数
            type: Number,
            default: 10,
        },
        currentUnit: {  //每页条数
            type: Number,
            default: 10,
        },
        listOfBars: {  //每页条数列表
            type: Array,
            default: () => [10, 20, 30, 40],
        }
    },
    data () {
        return {
            totalPager : 1, //总页数
            currPager: 1, //当前页
            unitPager: 10, //每页条数
            listOfSelect: [] // 每页条数的列表
        }
    },
    created () {
        this.initSelectList();
        this.initPager();
    },
    computed: {
        pages() {
            const c = this.currPager;
            const t = this.totalPager;

            if (t <= 0) return [0];
            if (t > 0 && t < 11) {
                const temp = [];
                for (let i = 1; temp.push(i++) < t;){};
                return temp;
            } 
            if (c <= 5) return [1, 2, 3, 4, 5, 6, 7, 8, 9, '...', t];
            else if (c >= t - 4) return [1, '...', t-8, t-7, t-6, t-5, t-4, t-3, t-2, t-1, t];
            else return [1, '...', c-3, c-2, c-1, c, c+1, c+2, c+3, '...', t];
        }
    },
    methods: {
        // 初始化每页条数的列表
        initSelectList () {
            this.unitPager = this.currentUnit;
            this.listOfSelect = this.listOfBars;
            this.listOfSelect.push(this.currentUnit);
            this.listOfSelect = [...new Set(this.listOfSelect.sort((a, b)=> a - b))];
        },
        // 初始化总页数和当前页
        initPager () {
            this.totalPager = Math.ceil(this.totalCount / this.unitPager);
            this.currPager = this.currentPager > this.totalPager ? this.totalPager : this.currentPager;
        },
        // 过滤其它字符，只能输入正整数
        fliterNumber (e) {
            if(e.currentTarget.value.length === 1){
                e.currentTarget.value = e.currentTarget.value.replace(/[^1-9]/g,'');
            } else{
                e.currentTarget.value = e.currentTarget.value.replace(/\D/g,'');
            }
        },
        // 选择每页条数
        changeUnit (e) {
            this.unitPager = e.currentTarget.value;
            this.initPager();
            this.$emit('on-changeUnit', Number(this.unitPager), this.currPager);
        },
        // 上一页
        prevPage () {
            if (this.currPager === 0) return;

            const targetPage = this.currPager - 1;
            this.currPager = targetPage < 1 ? 1 : targetPage;

            this.sendPager();
        },
        // 下一页
        nextPage () {
            if (this.currPager === this.totalPager) return;

            const targetPage = this.currPager + 1;
            this.currPager = targetPage > this.totalPager ? this.totalPager : targetPage;

            this.sendPager();
        },
        // 点击某页跳转
        jumpPager (e, page) {
            if (page === this.currPager) return;
            if (typeof page === 'string') {
                const prevVal = Number(e.currentTarget.previousElementSibling.innerHTML);
                const nextVal = Number(e.currentTarget.nextElementSibling.innerHTML);
                page = (prevVal & nextVal) + ((prevVal ^ nextVal) >>> 1);
            }
            this.currPager = page;

            this.sendPager();
        },
        // 去到某一页
        goPager (e) {
            const pagerValue = Number(e.currentTarget.previousElementSibling.previousElementSibling.value);
            
            if (pagerValue <= 0 || isNaN(pagerValue)) {
                this.$Message.info("请输入有效页码");
        
            } else {
                if (pagerValue > this.totalPager){
                    this.currPager = this.totalPager;

                } else this.currPager = pagerValue;

                this.sendPager();
            }

            e.currentTarget.previousElementSibling.previousElementSibling.value = this.currPager;
        },
        // 发送给父组件 
        sendPager () {
            this.$emit('on-getCurrentPager', this.currPager);
        }
    },
    watch: {
        totalCount (newValue, oldValue) {
            (newValue !== oldValue) && this.initPager();
        }
    }
}
</script>
<style scoped>
/* 分页器容器 */
.pager-container {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    /* height: 26px; */
    font-size: 12px;
    line-height: 32px;
	letter-spacing: 0px;
    font-family: MicrosoftYaHei;
	font-weight: normal;
	font-stretch: normal;
	color: #333333;
}
/* 页码样式 */
.pager-selected {
    display: flex;
    display: -webkit-flex;
    align-items: center;
}

.pager-selected div {
    min-width: 31px;
    height: 26px;
    padding: 0 2px;
    line-height: 26px;
    text-align: center;
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
}

.pager-number,
.yes-cursor {
    cursor: pointer;
}
/* 按钮选中样式 */
.on-selected,
.pager-number:hover {
    color: #ffffff;
    background-color: #2783f2;
    border-radius: 2px;
}
/* 选中的鼠标形状 */
.mouse-selected {
    cursor: pointer;
}
/* 箭头容器 */
.arrow-container {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
}
/* 右箭头 */
.gt {
    width: 7px;
    height: 7px;
    border-top: 1px solid #000000;
    border-right: 1px solid #000000;
    transform: rotate(45deg);
}

.no-gt {
    width: 7px;
    height: 7px;
    border-top: 1px solid #999999;
    border-right: 1px solid #999999;
    transform: rotate(45deg);
}
/* 左箭头 */
.lt {
    width: 7px;
    height: 7px;
    border-top: 1px solid #000000;
    border-left: 1px solid #000000;
    transform: rotate(-45deg);
}

.no-lt {
    width: 7px;
    height: 7px;
    border-top: 1px solid #999999;
    border-left: 1px solid #999999;
    transform: rotate(-45deg);
}

.not-cursor{
    cursor: not-allowed;
}
/* 页面跳转 */
.pager-go {
    display: flex;
    display: -webkit-flex;
    width: 156px;
    align-items: center;
    flex-wrap:wrap;
    justify-content:space-around;
}

.pager-go span {
	font-size: 12px;
	line-height: 32px;
    color: #999999;
}

.pager-go input {
    width: 40px;
    height: 26px;
    line-height: 24px;
    font-size: 12px;
    text-align: center;
	border-radius: 2px;
    border: solid 1px #e2e2e2;
    outline: none;
    background:none;
}

.pager-unit {
    display: flex;
    display: -webkit-flex;
    min-width: 130px;
    align-items: center;
    flex-wrap:wrap;
    justify-content:space-around;
    margin-left: 5px;
}

.pager-unit span {
    font-size: 12px;
	line-height: 32px;
}
/* 每页条数 */
.pager-unit select {
    min-width: 75px;
    height: 26px;
    line-height: 24px;
    font-size: 12px;
    padding-left: 4px;
    margin-left: 13px;
	border-radius: 2px;
    border: solid 1px #e2e2e2;
    outline: none;
    cursor: pointer;
}

.pager-unit select option {
    line-height: 24px;
    font-size: 12px;
}
</style>